import React from 'react'
import { Row, Col, Typography, Button, Card } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import './PatientSectionHeader.css'

const { Title, Text } = Typography

const PatientSectionHeader = ({
  icon,
  title,
  subtitle,
  onBack,
  color = '24, 144, 255', // Default blue
  variant = 'gradient', // 'gradient', 'minimal', 'medical'
  showBackButton = false,
  backButtonText = 'Back'
}) => {
  const renderGradientHeader = () => (
    <Card
      className='patient-section-header gradient-header'
      style={{
        background: `linear-gradient(135deg, rgba(${color}, 1) 0%, rgba(${color}, 0.8) 100%)`,
        border: 'none',
        borderRadius: '16px',
        marginBottom: '24px'
      }}
    >
      <Row align='middle' justify='space-between' gutter={[16, 8]}>
        <Col flex='auto'>
          <div className='gradient-header-content'>
            {icon && (
              <div className='gradient-icon-container'>
                <FontAwesomeIcon icon={icon} />
              </div>
            )}
            <div className='gradient-text-content'>
              <Title level={2} className='gradient-title'>
                {title}
              </Title>
              {subtitle && <Text className='gradient-subtitle'>{subtitle}</Text>}
            </div>
          </div>
        </Col>

        {(onBack || showBackButton) && (
          <Col>
            <Button
              type='default'
              icon={<FontAwesomeIcon icon={faArrowLeft} />}
              onClick={onBack}
              className='gradient-back-button'
              size='large'
            >
              {backButtonText}
            </Button>
          </Col>
        )}
      </Row>
    </Card>
  )

  const renderMinimalHeader = () => (
    <div className='patient-section-header minimal-header' style={{ marginBottom: '24px' }}>
      <Row align='middle' justify='space-between' gutter={[16, 8]}>
        <Col flex='auto'>
          <div className='minimal-header-content'>
            {icon && (
              <div className='minimal-icon-container' style={{ color: `rgba(${color}, 1)` }}>
                <FontAwesomeIcon icon={icon} />
              </div>
            )}
            <div className='minimal-text-content'>
              <Title level={2} className='minimal-title'>
                {title}
              </Title>
              {subtitle && <Text className='minimal-subtitle'>{subtitle}</Text>}
            </div>
          </div>
        </Col>

        {(onBack || showBackButton) && (
          <Col>
            <Button
              type='default'
              icon={<FontAwesomeIcon icon={faArrowLeft} />}
              onClick={onBack}
              className='minimal-back-button'
              size='large'
            >
              {backButtonText}
            </Button>
          </Col>
        )}
      </Row>
    </div>
  )

  const renderMedicalHeader = () => (
    <div
      className='patient-section-header medical-header'
      style={{
        background: `rgba(${color}, 0.05)`,
        borderRadius: '16px',
        padding: '24px',
        marginBottom: '24px',
        border: `1px solid rgba(${color}, 0.1)`,
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
      }}
    >
      <Row align='middle' justify='space-between' gutter={[16, 8]}>
        <Col flex='auto'>
          <div className='medical-header-content'>
            {icon && (
              <div
                className='medical-icon-container'
                style={{
                  background: `rgba(${color}, 0.1)`,
                  boxShadow: `0 0 20px 0 rgba(${color}, 0.3)`,
                  color: `rgba(${color}, 1)`
                }}
              >
                <FontAwesomeIcon icon={icon} />
              </div>
            )}
            <div className='medical-text-content'>
              <Title level={2} className='medical-title'>
                {title}
              </Title>
              {subtitle && <Text className='medical-subtitle'>{subtitle}</Text>}
            </div>
          </div>
        </Col>

        {(onBack || showBackButton) && (
          <Col>
            <Button
              type='default'
              icon={<FontAwesomeIcon icon={faArrowLeft} />}
              onClick={onBack}
              className='medical-back-button'
              size='large'
            >
              {backButtonText}
            </Button>
          </Col>
        )}
      </Row>
    </div>
  )

  switch (variant) {
    case 'gradient':
      return renderGradientHeader()
    case 'minimal':
      return renderMinimalHeader()
    case 'medical':
      return renderMedicalHeader()
    default:
      return renderGradientHeader()
  }
}

export default PatientSectionHeader
